module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head_office":"Head Office"}}')
  delete Component.options._Ctor
}
